import { QueryFeature } from '../../../../../config/queryClient';

enum QueryKey {
  Workflow = 'Workflow',
  Accounts = 'Accounts',
  DafAccounts = 'DafAccounts',
}

export const queryKeys = {
  workflow: (clientId: number, goalId?: string | null) => [
    QueryFeature.CharitableGivingWorkflow,
    QueryKey.Workflow,
    clientId,
    goalId,
  ],

  accounts: (
    clientId: number,
    givingStrategy: number | null,
    kindOfProperty: number | null,
    donor: number | null,
  ) => [
    QueryFeature.CharitableGivingWorkflow,
    QueryKey.Accounts,
    clientId,
    givingStrategy,
    kindOfProperty,
    donor,
  ],

  accountsAll: () => [QueryFeature.CharitableGivingWorkflow, QueryKey.Accounts],

  dafAccounts: (clientId: number, goalId: string | null = null) => [
    QueryFeature.CharitableGivingWorkflow,
    QueryKey.DafAccounts,
    clientId,
    goalId,
  ],
};
